import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import { NeedsNewTitlesOCRdDto, NeedsNewTitlesOCRdQueryParams } from 'dtos/toDoLists/ohioBuildABoxes'
import { URIQuery } from 'utils'

const baseUrl = (): string => `/api/to-do-lists/ohio-build-a-boxes/needs-new-titles-ocrd`

export const getNeedsNewTitlesOCRdToDoList = (queryParams: NeedsNewTitlesOCRdQueryParams) =>
  apiClient.get<ApiResponse<NeedsNewTitlesOCRdDto[]>>(baseUrl() + URIQuery(queryParams)).then(res => res.data)
